var _g, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#F2F6FB",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 5.6,
    y1: 6.2,
    x2: 18.4,
    y2: 6.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 7.9,
    x2: 10.9,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.5,
    y1: 7.9,
    x2: 13.1,
    y2: 19
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "9.1,9.4 14.9,9.4 12,14.4",
    fill: "#F2F6FB",
    stroke: "#F2F6FB",
    strokeWidth: 1.1,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.66d9e4c144abaf264512d5b43bdcb1a4.svg";
export { ForwardRef as ReactComponent };